/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tournament_Registered_CountInputs */



/**
* | output |
* | --- |
* | "{count} registered" |
*
* @param {Tournament_Registered_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_registered_count = /** @type {((inputs: Tournament_Registered_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Registered_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} inscrits`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} inscritos`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} inscritos`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} iscritti`)
	return /** @type {LocalizedString} */ (`${i?.count} registered`)
});